var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"hiddenForm",staticStyle:{"display":"none"},attrs:{"id":"hiddenForm","method":"post","action":_vm.params.url,"target":"_blank"}},_vm._l((_vm.getPayloadItems),function(item,index){return _c('input',{key:index,attrs:{"type":"hidden","name":item.name},domProps:{"value":item.value}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }